export const PREVIEW_ERROR = 'preview_error';

// minimum viewport pixel width for desktop
export const DESKTOP_BREAKPOINT = 1095;
// minimum viewport pixel width for tablet
export const TABLET_BREAKPOINT = 768;
